/* tslint:disable */

declare var Object: any;
export interface DepositTypeInterface {
  "name": string;
  "description"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class DepositType implements DepositTypeInterface {
  "name": string;
  "description": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: DepositTypeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `DepositType`.
   */
  public static getModelName() {
    return "DepositType";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of DepositType for dynamic purposes.
  **/
  public static factory(data: DepositTypeInterface): DepositType{
    return new DepositType(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'DepositType',
      plural: 'DepositTypes',
      path: 'DepositTypes',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
